var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('HeaderView'),_c('BreadList'),(_vm.isRouterAlive)?_c('router-view'):_vm._e(),_c('FooterView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }